import React, { useState, useEffect, useMemo } from 'react';
import './ContenedorMaterias.css';
import BotonMateria from './BotonMateria';
import imagen_materia from '../Assets/materia.jpg';
import axios from 'axios';
import { getClases } from '../Pages/constants';
import { useData } from '../Pages/DataContext';
import { SORT_CRITERIA, SORT_OPTIONS, sortCourses } from './sortUtils';

const ContenedorMaterias = ({ redireccionB }) => {
  const [materias, setMaterias] = useState([]);
  const { setClaseData } = useData();

  // Paginación
  const [paginaActual, setPaginaActual] = useState(1);
  const materiasPorPagina = 9;

  // Buscador y ordenamiento
  const [searchTerm, setSearchTerm] = useState('');
  const [sortCriterion, setSortCriterion] = useState(SORT_CRITERIA.RECENT);

  useEffect(() => {
    const fetchMaterias = async () => {
      try {
        const { data } = await axios.get(getClases);
        setMaterias(data);
      } catch (error) {
        console.error('Error al obtener las materias:', error);
      }
    };
    fetchMaterias();
  }, []);

  const editarClase = (val) => {
    setClaseData(val);
    console.log('Valores de clase: ', val);
  };

  const orderedMaterias = useMemo(() => {
    const termino = searchTerm.toLowerCase();
    const filteredMaterias = materias.filter((materia) =>
      (materia.nombre_clase || '').toLowerCase().includes(termino)
    );

    return sortCourses(filteredMaterias, sortCriterion);
  }, [materias, searchTerm, sortCriterion]);

  // Total de páginas (puede ser 0 si no hay resultados)
  const totalPaginas = Math.ceil(orderedMaterias.length / materiasPorPagina);

  // Asegurar que paginaActual siempre esté dentro [1, totalPaginas] cuando cambie el filtro u orden
  useEffect(() => {
    setPaginaActual(1);
  }, [searchTerm, sortCriterion]);

  useEffect(() => {
    if (totalPaginas > 0 && paginaActual > totalPaginas) {
      setPaginaActual(totalPaginas);
    }
  }, [totalPaginas, paginaActual]);

  // Materias de la página actual: se ordenan antes de paginar
  const paginaSegura = totalPaginas === 0 ? 1 : paginaActual;
  const indiceUltima = paginaSegura * materiasPorPagina;
  const indicePrimera = indiceUltima - materiasPorPagina;
  const materiasActuales = orderedMaterias.slice(indicePrimera, indiceUltima);

  return (
    <div className="contenedor-materias">
      <div className="materias-toolbar">
        <div className="buscador">
          <label htmlFor="materias-search" className="materias-control-label">Buscar materia</label>
          <input
            id="materias-search"
            type="text"
            placeholder="Nombre del curso"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        <label className="ordenamiento-control">
          <span className="materias-control-label">Ordenar por</span>
          <select
            value={sortCriterion}
            onChange={(event) => setSortCriterion(event.target.value)}
          >
            {SORT_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      </div>

      {/* Lista o mensaje vacío */}
      {orderedMaterias.length === 0 ? (
        <p className="sin-materias">No hay materias.</p>
      ) : (
        materiasActuales.map((materia) => (
          <BotonMateria
            key={materia.id_clase || materia.matricula_clase}
            imagen={imagen_materia}
            nombre={materia.nombre_clase}
            descripcion={materia.descripcion}
            salon={materia.matricula_clase}
            profesor={materia.matricula_maestro}
            redireccion={redireccionB}
            onEditarClase={() => editarClase(materia)}
          />
        ))
      )}

      {/* Paginación: se oculta si no hace falta */}
      {totalPaginas > 1 && (
        <div className="paginacion">
          <button
            onClick={() => setPaginaActual(1)}
            disabled={paginaActual === 1}
          >
            Primera
          </button>

          <button
            onClick={() => setPaginaActual((p) => Math.max(1, p - 1))
            }
            disabled={paginaActual === 1}
          >
            Anterior
          </button>

          <span className="pagina-info">
            Página {paginaActual} de {totalPaginas}
          </span>

          <button
            onClick={() =>
              setPaginaActual((p) => Math.min(totalPaginas, p + 1))
            }
            disabled={paginaActual === totalPaginas}
          >
            Siguiente
          </button>

          <button
            onClick={() => setPaginaActual(totalPaginas)}
            disabled={paginaActual === totalPaginas}
          >
            Última
          </button>
        </div>
      )}
    </div>
  );
};

export default ContenedorMaterias;
